export {};
//# sourceMappingURL=propArguments.js.map